import { useState } from 'react'
import { SettingPageTitle } from '../components/header/SettingPageTitle'
import Button from 'app/components/Button'
import CookieCustomizationDrawer from '../components/drawer/CookieCustomizationDrawer'
import CookieGuideDrawer from '../components/drawer/CookieGuideDrawer'

interface DrawerState {
  customize: boolean
  guide: boolean
}

interface CookieSettingCard {
  id: string
  title: string
  icon: JSX.Element
  buttonText: string
  drawerType: keyof DrawerState
}

const SettingCookie = () => {
  const [drawerStates, setDrawerStates] = useState<DrawerState>({
    customize: false,
    guide: false,
  })

  const handleDrawerToggle = (drawerType: keyof DrawerState) => {
    setDrawerStates((prev) => ({
      ...prev,
      [drawerType]: !prev[drawerType],
    }))
  }

  const cookieSettingCards: CookieSettingCard[] = [
    {
      id: 'customize',
      title: 'Customize your cookie widget & window',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className='icon icon-tabler icons-tabler-outline icon-tabler-palette'
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25' />
          <path d='M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
          <path d='M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
          <path d='M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
        </svg>
      ),
      buttonText: 'Customize',
      drawerType: 'customize',
    },
    {
      id: 'guide',
      title: 'Install cookie widget on your website',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className='icon icon-tabler icons-tabler-outline icon-tabler-cookie'
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path stroke='none' d='M0 0h24v24H0z' />
          <path d='M8 13v.01' />
          <path d='M12 17v.01' />
          <path d='M12 12v.01' />
          <path d='M16 14v.01' />
          <path d='M11 8v.01' />
          <path d='M13.148 3.476l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296q -.745 1.18 -1.024 1.852q -.283 .684 -.66 2.216a3 3 0 0 1 -1.624 1.623q -1.572 .394 -2.216 .661q -.712 .295 -1.852 1.024a3 3 0 0 1 -2.296 0q -1.203 -.754 -1.852 -1.024q -.707 -.292 -2.216 -.66a3 3 0 0 1 -1.623 -1.624q -.397 -1.577 -.661 -2.216q -.298 -.718 -1.024 -1.852a3 3 0 0 1 0 -2.296q .719 -1.116 1.024 -1.852q .257 -.62 .66 -2.216a3 3 0 0 1 1.624 -1.623q 1.547 -.384 2.216 -.661q .687 -.285 1.852 -1.024a3 3 0 0 1 2.296 0' />
        </svg>
      ),
      buttonText: 'View Installation Guide',
      drawerType: 'guide',
    },
  ]

  const renderCard = ({ id, title, icon, buttonText, drawerType }: CookieSettingCard) => (
    <div className='row mb-6' key={id}>
      <div className='col-12'>
        <div
          className='card bg-white d-flex flex-column gap-6 py-3 '
        >
          <div className='card-body py-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <div
                  className='d-flex align-items-center justify-content-center me-3'
                  style={{
                    backgroundColor: '#F3F4F6',
                    borderRadius: '6px',
                    height: '48px',
                    width: '48px',
                  }}
                >
                  {icon}
                </div>
                <span className='lh-base text-gray-900 fw-medium' style={{ fontSize: '14px' }}>
                  {title}
                </span>
              </div>
              <Button onClick={() => handleDrawerToggle(drawerType)}>{buttonText}</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <>
      <SettingPageTitle icon='Settings.svg' title='Settings' desc='Manage your settings'>
        Cookie Widget
      </SettingPageTitle>
      <div>{cookieSettingCards.map(renderCard)}</div>
      <CookieCustomizationDrawer
        isOpen={drawerStates.customize}
        onClose={() => handleDrawerToggle('customize')}
      />
      <CookieGuideDrawer
        isOpen={drawerStates.guide}
        onClose={() => handleDrawerToggle('guide')}
      />
    </>
  )
}

export default SettingCookie
